/*
* 阔地教育科技有限公司版权所有（codyy.com/codyy.cn）.
* Copyright (c) 2019, Codyy and/or its affiliates. All rights reserved.
* @Date: 2020.02.25 10:19.
* @Author
* @Description 辽宁点播项目 - 头部
**/
<template>
    <header class="ln-header">
        <div class="w1200">辽宁朝阳点播系统</div>
    </header>
</template>

<script>
export default {
  name: 'HeaderNav',
}
</script>

<style lang="scss" scoped>
    .ln-header {
        font-size: 24px;
        display: flex;
        align-items: center;
        height: 60px;
        color: #fff;
        background: #1880d9;
    }
    .w100 {
        .ln-header {
            font-size: 16px;
            height: 40px;
            text-align: center;
        }
    }
</style>
